import {
  activateControl,
  consumeKeyboardEvent,
  isEditableKeyboardTarget,
  isElementInTopDialog,
  isKeyboardScopeActive,
  shouldPreventNamedFieldEnter,
  trapTabInOwningDialog,
} from "@/utils/crudKeyboard";

export default {
  data() {
    return {
      keyboardShortcutsDialog: false,
    };
  },
  computed: {
    crudFormKeyboardShortcuts() {
      const shortcuts = [
        {
          teclas: "Ctrl / ⌘ + S",
          descricao: "Salvar_o_formulario_atual",
        },
        {
          teclas: "Ctrl / ⌘ + Enter",
          descricao: "Salvar_o_formulario_atual",
        },
        {
          teclas: "Ctrl / ⌘ + /",
          descricao: "Exibir_esta_lista_de_atalhos",
        },
      ];
      if (!this.isCrudFormSubmitAvailable()) shortcuts.splice(0, 2);
      if (this.closeWithCrudDialog) {
        shortcuts.splice(shortcuts.length - 1, 0, {
          teclas: "Esc",
          descricao: "Fechar_o_formulario_em_modal",
        });
      }
      return shortcuts;
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleCrudFormKeydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleCrudFormKeydown);
  },
  methods: {
    isCrudFormKeyboardActive(event) {
      return (
        this.keyboardShortcutsEnabled !== false &&
        isKeyboardScopeActive(this.$el, ".crud-form-page", event?.target)
      );
    },
    openKeyboardShortcuts() {
      this.keyboardShortcutsDialog = true;
    },
    closeKeyboardShortcuts() {
      this.keyboardShortcutsDialog = false;
    },
    isCrudFormSubmitAvailable() {
      return !(
        this.disableSubmit === true ||
        (this.$options.name === "EditarBase" &&
          this.nomeSingular === "ProdutoCentroEstoque")
      );
    },
    isCrudFormInTopDialog() {
      return isElementInTopDialog(this.$el);
    },
    submitByKeyboard() {
      if (
        !this.isCrudFormSubmitAvailable() ||
        this.loading ||
        !this.contentReady ||
        this.submited
      ) {
        return false;
      }
      const activeElement = this.$el?.ownerDocument?.activeElement;
      if (
        activeElement &&
        this.$el?.contains(activeElement) &&
        isEditableKeyboardTarget(activeElement)
      ) {
        activeElement.blur();
      }
      this.$nextTick(() => activateControl(this.$refs.botaoSalvar));
      return true;
    },
    handleCrudFormKeydown(event) {
      if (event.defaultPrevented || !this.isCrudFormKeyboardActive(event)) {
        return;
      }

      if (shouldPreventNamedFieldEnter(event)) {
        event.preventDefault();
        return;
      }

      if (event.key === "Tab") {
        trapTabInOwningDialog(this.$el, event);
        return;
      }

      const key = String(event.key || "");
      const keyLower = key.toLowerCase();
      const ctrlOrCmd = event.ctrlKey || event.metaKey;

      if (
        ctrlOrCmd &&
        !event.shiftKey &&
        !event.altKey &&
        this.isCrudFormSubmitAvailable() &&
        (keyLower === "s" || key === "Enter")
      ) {
        consumeKeyboardEvent(event);
        this.submitByKeyboard();
        return;
      }

      if (
        key === "/" &&
        ctrlOrCmd &&
        !event.shiftKey &&
        !event.altKey &&
        !event.repeat
      ) {
        consumeKeyboardEvent(event);
        this.openKeyboardShortcuts();
        return;
      }

      if (
        (key === "Escape" || key === "Esc") &&
        this.isCrudFormInTopDialog() &&
        !this.loading
      ) {
        consumeKeyboardEvent(event);
        this.closeModal();
      }
    },
  },
};
